import chunk from 'lodash.chunk';
const DEXF_MAX_CHUNK_SIZE = 50;
const DEXF_CONFIGURATION_API_BASE_URL = 'https://api.dexf.ikea.com/vpc/v1/query/configurations';
const mapDexfConfigurationToVpcConfiguration = (dexfConfigurationItem) => ({
    imageUrl: dexfConfigurationItem.content.image,
    itemList: (dexfConfigurationItem.content.itemList.item || []).map(i => ({
        id: i.itemNo,
        type: i.itemType,
        quantity: i.quantity
    })),
    origin: dexfConfigurationItem.retailUnit,
    configurationId: dexfConfigurationItem.configurationId,
    configurationVersion: dexfConfigurationItem.content.configuration.version,
    application: dexfConfigurationItem.content.application.toUpperCase(),
    icf: dexfConfigurationItem.content.icf,
    configuration: dexfConfigurationItem.content.configuration.content
});
const hasDexfConfigurationItemImage = (dexfConfigurationItem) => {
    return dexfConfigurationItem.content.image && dexfConfigurationItem.content.image.length > 0;
};
/**
 * Fetches multiple VPC configurations for the given ids.
 *
 * @param vpcIds - list of vpc ids
 */
export async function getBatchedConfigurationsByIds(vpcIds, dexfApiKey) {
    const vpcIdChunks = chunk(vpcIds, DEXF_MAX_CHUNK_SIZE);
    const configurationRequests = vpcIdChunks.map(chunk => fetchConfigurationChunk(chunk, dexfApiKey));
    const configurations = (await Promise.all(configurationRequests)).flat();
    return configurations;
}
const fetchConfigurationChunk = async (vpcIds, dexfApiKey) => {
    const response = await fetch(`${DEXF_CONFIGURATION_API_BASE_URL}/batchload?&filter.configurationId=${vpcIds.join(',')}`, {
        headers: {
            accept: 'application/json',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'DEXF-API-KEY': dexfApiKey
        }
    });
    const result = await response.json();
    const data = result.data
        .filter(hasDexfConfigurationItemImage)
        .map(mapDexfConfigurationToVpcConfiguration);
    return data;
};
//# sourceMappingURL=vpc.js.map